export var StateHistoryErrorCode;
(function (StateHistoryErrorCode) {
    StateHistoryErrorCode["CannotFindDevice"] = "CannotFindDevice";
    StateHistoryErrorCode["ResponseTypeNotSupported"] = "ResponseTypeNotSupported";
    StateHistoryErrorCode["InvalidChannelNumber"] = "InvalidChannelNumber";
    StateHistoryErrorCode["IncorrectLimitValue"] = "IncorrectLimitValue";
    StateHistoryErrorCode["IncorrectOffsetValue"] = "IncorrectOffsetValue";
    StateHistoryErrorCode["OtherError"] = "OtherError";
    StateHistoryErrorCode["FatalError"] = "FatalError";
    StateHistoryErrorCode["NoData"] = "NoData";
    StateHistoryErrorCode["FunctionalityNotSupported"] = "FunctionalityNotSupported";
})(StateHistoryErrorCode || (StateHistoryErrorCode = {}));
//# sourceMappingURL=IStatesHistoryService.js.map